import { TranslationKeys } from '../english/profile.i18n';

export const keys: TranslationKeys = {
  profile: {
    back: 'Retour',
    title: 'Mon compte',
    subtitle:
      "Gérez votre profil ici. Veuillez noter que la modification de votre adresse courriel mettra également à jour l'adresse courriel que vous utilisez pour vous connecter.",
    fields: {
      name: 'Nom',
      email: 'Adresse courriel',
      phoneNumber: 'Numéro de téléphone',
    },
    editEmailDialog: {
      title: "Modification d'adresse courriel",
      fields: {
        email: {
          label: 'Quelle est votre nouvelle adresse courriel?',
          placeholder: 'Adresse courriel',
        },
        passcode: {
          label: "Entrez le code à 6 chiffres que nous venons d'envoyer à {{0}}:",
          placeholder: "Code d'authentification",
          invalid: 'Code invalide',
        },
      },
      conflict: {
        content:
          'Oops, il y a déjà un compte associé à ce courriel. Utilisez un courriel différent ou <0>contactez le support</0>.',
        ok: 'Ok',
      },
    },
    undoEdit: 'Annuler',
    confirmEdit: 'Confirmer',
    editTooltip: 'Modifier',
  },
};

export default keys;
